import axios from "axios";
import { DispatcherEventFilter, EventFilter, SearchRequest } from "./Types";

export default {
  getRegistry(page: number, count: number, filter: DispatcherEventFilter) {
    return axios.post(`/sp/event/search`, {
      ...filter,
      page: this.paginator.page,
      count: this.paginator.perPage,
    });
  },
  updateStatus(request) {
    return axios.put("/sp/DefectVerification/updatestatus", request);
  },
  exportDispatcherTable(filter: DispatcherEventFilter) {
    const options = { responseType: "blob", params: filter };
    // @ts-ignore
    return axios.get("/sp/DefectVerification/export", options).then((response) => {
      const blob = new Blob([response.data], { type: response.data.type });
      const link = document.createElement("a");
      const contentDisposition = response.headers["content-disposition"];
      let filename = "defects";
      if (contentDisposition) {
        const matches = contentDisposition.match(/filename=([\w\d\-_.]+)/);
        if (matches.length === 2) {
          filename = matches[1];
        }
      }
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      link.click();
      URL.revokeObjectURL(link.href);
    });
  },
};
